// extracted by mini-css-extract-plugin
export default {"profile":"UserProfile_profile__w4aP6"};